import React, { Fragment } from 'react';
import { Route } from 'react-router-dom';
import { Title } from '../shared';
import Wrapper from '../shared/errors/wrapper';

export const Forbidden = () => {
  return (
    <Route
      render={({ staticContext }) => {
        if (staticContext) {
          staticContext.statusCode = 403;
        }
        return (
          <Fragment>
            <Title description="You are not allowed to navigate to this page" title="Forbidden" />
            <Wrapper title="Forbidden" />
          </Fragment>
        );
      }}
    />
  );
};
